module.exports = __webpack_public_path__ + "img/connection-broadcasting.f098c6a8.svg";